import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import _ from 'lodash';
import {
  Avatar,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  GetApp as GetAppIcon,
  Visibility as PreviewIcon
} from '@mui/icons-material';
import config from 'src/utils/config';
import getInitials from 'src/utils/getInitials';
import downloadAckApi from 'src/requests/downloadAck';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(1)
  },
  statsIcon: {
    marginLeft: theme.spacing(1)
  }
}));

const Results = ({ className, cases, ...rest }) => {
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ textAlign: 'center' }}>
                  Acknowledgement
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Name
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Issue
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Created On
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Closed On
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Days/Worked
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Billed/Billable
                </TableCell>
                <TableCell style={{ textAlign: 'center' }}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cases.slice((page * limit), limit + (page * limit)).map((caseInfo) => (
                <TableRow
                  hover
                  key={caseInfo.id}
                >
                  <TableCell>
                    <Box
                      alignItems="center"
                      display="flex"
                    >
                      <Avatar
                        variant="square"
                        className={classes.avatar}
                        src={`/static/images/cases/${_.lowerCase(_.get(caseInfo, ['product_details', 'Product Type'], 'service')).replace(/\s+/g, '-')}.png`}
                      >
                        {getInitials(`${caseInfo.customer.first_name} ${caseInfo.customer.last_name}`)}
                      </Avatar>
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {caseInfo.case_id}
                      </Typography>
                      {_.includes(rest.roles, 'view-acknowledgements')
                        && (
                        <PreviewIcon
                          className={classes.statsIcon}
                          color="action"
                          onClick={() => rest.getPreviewInvoice(caseInfo.case_id)}
                        />
                        )}
                      {_.includes(rest.roles, 'download-acknowledgements')
                        && (
                        <GetAppIcon
                          className={classes.statsIcon}
                          color="action"
                          onClick={() => downloadAckApi(caseInfo.case_id)}
                        />
                        )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {`${caseInfo.customer.first_name} ${caseInfo.customer.last_name}`}
                  </TableCell>
                  <TableCell>
                    {caseInfo.issue}
                  </TableCell>
                  <TableCell>
                    {moment(caseInfo.date_added).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    {caseInfo.closed_on ? moment(caseInfo.closed_on).format('DD/MM/YYYY') : 'Work In Progress'}
                  </TableCell>
                  <TableCell>
                    {`${moment(caseInfo.closed_on ? caseInfo.closed_on : undefined).diff(moment(caseInfo.date_added), 'days') + 1} days`}
                  </TableCell>
                  <TableCell>
                    {`${config.currencySymbol}${caseInfo.closed_on ? caseInfo.final_cost : caseInfo.approximated_cost}`}
                  </TableCell>
                  <TableCell>
                    <p
                      style={{
                        border: `1px solid ${caseInfo.status !== 'Delivered' ? 'red' : 'green'}`,
                        borderRadius: '100%',
                        padding: '5px 10px',
                        textAlign: 'center'
                      }}
                    >
                      {caseInfo.status}
                    </p>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={cases.length}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[10, 25, 50, 100]}
      />
    </Card>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  cases: PropTypes.array.isRequired,
};

export default Results;
